export default "__VITE_ASSET__DLX15HdM__"